import React from 'react';

import { faAdd } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';

import { Button } from '@mui/material';
import { ButtonProps } from '@mui/material/Button';

import { FontAwesomeSvgIcon } from '../index';

interface CreateButtonProps extends ButtonProps {
  label?: string;
  ml?: number | 'auto';
}

/**
 * This button is mostly used for creating a new record at admin tables
 */
const CreateButton: React.FC<CreateButtonProps> = ({ onClick, label, ml }) => {
  const { t } = useTranslation('common');

  return (
    <div style={{ display: 'flex' }}>
      <Button
        variant="contained"
        color="dark"
        startIcon={<FontAwesomeSvgIcon icon={faAdd} sx={{ m: 'auto' }} />}
        onClick={onClick}
        sx={{ ml: ml || 'auto', alignItems: 'left' }}
      >
        {label ? label : t('new')}
      </Button>
    </div>
  );
};

export default CreateButton;
